import { api, authHeader } from "../configs/axiosConfigs";

const portalBase = "/SLN/DistributionCompany/DistributionPortal";
const reviewOperatorBase = "/SLN/SolarentOperator/DistributionReview";
const reviewSupervisorBase = "/SLN/Supervisor/DistributionReview";

const unwrap = (response) => response?.data ?? response;

const DistributionReviewApi = {
  getPortalContext: async (companyId) =>
    unwrap(
      await api.request({
        url: `${portalBase}/GetContext`,
        method: "GET",
        params: companyId ? { companyId } : undefined,
        headers: authHeader(),
      })
    ),

  listMembers: async (companyId) =>
    unwrap(
      await api.request({
        url: `${portalBase}/ListMembers`,
        method: "GET",
        params: { companyId },
        headers: authHeader(),
      })
    ),

  listAreas: async (companyId) =>
    unwrap(
      await api.request({
        url: `${portalBase}/ListAreas`,
        method: "GET",
        params: { companyId },
        headers: authHeader(),
      })
    ),

  saveArea: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/SaveArea`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  saveMember: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/SaveMember`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  listUsers: async (companyId) =>
    unwrap(
      await api.request({
        url: `${portalBase}/ListUsers`,
        method: "GET",
        params: { companyId },
        headers: authHeader(),
      })
    ),

  saveUser: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/SaveUser`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  setAreaEngineeringEnabled: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/SetAreaEngineeringEnabled`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  searchPortalQueue: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/SearchQueue`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  getUnitDashboard: async ({ unit, distributionCompanyId } = {}) =>
    unwrap(
      await api.request({
        url: `${portalBase}/GetUnitDashboard`,
        method: "GET",
        params: {
          unit,
          ...(distributionCompanyId ? { distributionCompanyId } : {}),
        },
        headers: authHeader(),
      })
    ),

  decideArea: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/DecideArea`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  decideEngineering: async (body) =>
    unwrap(
      await api.request({
        url: `${portalBase}/DecideEngineering`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  getByRequestId: async (requestId) =>
    unwrap(
      await api.request({
        url: `${reviewOperatorBase}/GetByRequestId`,
        method: "GET",
        params: { requestId },
        headers: authHeader(),
      })
    ),

  getRoutingStatus: async (requestId) =>
    unwrap(
      await api.request({
        url: `${reviewOperatorBase}/GetRoutingStatus`,
        method: "GET",
        params: { requestId },
        headers: authHeader(),
      })
    ),

  getRoutingStatusAsSupervisor: async (requestId) =>
    unwrap(
      await api.request({
        url: `${reviewSupervisorBase}/GetRoutingStatus`,
        method: "GET",
        params: { requestId },
        headers: authHeader(),
      })
    ),

  chooseReferral: async (body) =>
    unwrap(
      await api.request({
        url: `${reviewOperatorBase}/ChooseReferral`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  referToDistributionAsOperator: async (body) =>
    unwrap(
      await api.request({
        url: `${reviewOperatorBase}/ReferToDistribution`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  referToDistributionAsSupervisor: async (body) =>
    unwrap(
      await api.request({
        url: `${reviewSupervisorBase}/ReferToDistribution`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  storeFinalPrice: async (body) =>
    unwrap(
      await api.request({
        url: `${reviewOperatorBase}/StoreFinalPrice`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  searchOperatorQueue: async (body) =>
    unwrap(
      await api.request({
        url: `${reviewOperatorBase}/SearchQueue`,
        method: "POST",
        data: body,
        headers: authHeader(),
      })
    ),

  getSupervisorOptions: async () =>
    unwrap(
      await api.request({
        url: "/SLN/SolarentOperator/SupervisionWorkQueue/GetFilterData",
        method: "GET",
        headers: authHeader(),
      })
    ),
};

export default DistributionReviewApi;
